import {
  ROOT,
  GET_REGISTER_INFO,
  UPDATE_REGISTER_INFO
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";

function get() {
  return fetch(ROOT + GET_REGISTER_INFO, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function update(data) {
  return fetch(ROOT + UPDATE_REGISTER_INFO, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

export const registerInfoService = {
  get,
  update
};
